import {
  createInertiaApp,
  router,
  type ResolvedComponent,
} from "@inertiajs/svelte";
import RootLayout from "$lib/layouts/Root.svelte";
import {
  capturePageview,
  identifyUser,
  initAnalytics,
  resetIdentity,
} from "$lib/analytics";

initAnalytics();

// Only reset on sign-out. Resetting on anonymous navigation would churn the
// server-seeded visitor_id and fragment the person across profiles.
let wasIdentified = false;
router.on("navigate", (event) => {
  const page = event.detail.page;
  const sharedUser = page.props?.currentUser as { id?: number } | undefined;
  if (sharedUser?.id) {
    identifyUser(sharedUser.id);
    wasIdentified = true;
  } else if (wasIdentified) {
    resetIdentity();
    wasIdentified = false;
  }
  capturePageview(page.url);
});

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob<ResolvedComponent>("../pages/**/*.svelte");
    const importer = pages[`../pages/${name}.svelte`];
    if (!importer) throw new Error(`Missing page: '${name}.svelte'`);
    return await importer();
  },

  layout: () => RootLayout,

  progress: {
    delay: 250,
    includeCSS: false,
    showSpinner: false,
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" };
    },
  },
});
